import React, { useEffect, useRef, useState } from "react";
import { SelectMenuOption, COUNTRIES } from "../../../helpers/index";
import { Search } from "../../../icons";
interface CountrySelectorProps {
  id: string;
  open: boolean;
  disabled?: boolean;
  onToggle: () => void;
  onChange: (selectedValue: { value: string; code: string }) => void;
  selectedValue: SelectMenuOption;
  customClass?: string;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({
  id,
  open,
  disabled = false,
  onToggle,
  onChange,
  selectedValue,
  customClass = "text-white",
}) => {
  const [query, setQuery] = useState("");
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node) && open) {
        onToggle();
        setQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onToggle]);

  const filteredCountries = COUNTRIES.filter(
    (country) =>
      country.title.toLowerCase().includes(query.toLowerCase()) ||
      country.code.toLowerCase().includes(query.toLowerCase()) ||
      country.value.toLowerCase().includes(query.toLowerCase()),
  );

  return (
    <div ref={ref}>
      <div className="relative w-20">
        <button
          type="button"
          className={
            `bg-[#262626] w-full rounded-lg md:py-3.5 py-3 text-white cursor-default focus:outline-none sm:text-sm flex justify-center ` +
            customClass
          }
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-labelledby="listbox-label"
          onClick={onToggle}
          disabled={disabled}
        >
          <span className={`flex items-center ` + customClass}>
            <img
              alt={`${selectedValue.value}`}
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${selectedValue.value}.svg`}
              className="inline mr-1 h-4 rounded-sm"
            />
            +{selectedValue.code}
          </span>
        </button>

        {open && (
          <div
            className={
              `absolute z-10 mt-4 bg-[#262626] rounded-md ` + customClass
            }
            style={{ width: ref.current?.parentElement?.offsetWidth || "100%" }}
          >
            <div
              className={
                `sticky top-0 z-10 bg-[#262626] rounded-md ` + customClass
              }
            >
              <div
                className={
                  `bg-[#262626] cursor-default px-4 py-2 rounded-md ` +
                  customClass
                }
              >
                <div className="relative mt-1">
                  <div className="absolute inset-y-0 left-2 mt-2 flex items-center h-4">
                    <Search width={16} height={16} />
                  </div>

                  <input
                    type="search"
                    name="search"
                    className={
                      `rounded-lg focus:outline-none block w-full pl-8 pr-2.5 py-1 bg-[#7676803D] placeholder-gray-400 text-white ` +
                      customClass
                    }
                    placeholder="Search"
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="max-h-64 px-4 py-4 overflow-y-scroll">
              {filteredCountries.length === 0 ? (
                <li className="text-white cursor-default select-none relative py-2 pl-3 pr-9">
                  No countries found
                </li>
              ) : (
                filteredCountries.map((value, index) => (
                  <li
                    key={`${id}-${index}`}
                    className={
                      `hover:text-white cursor-default select-none relative py-4 pl-3 pr-9 flex items-center transition border-b border-[#7676803D] mb-2 hover:bg-gray-800 ` +
                      customClass
                    }
                    id="listbox-option-0"
                    role="option"
                    onClick={() => {
                      onChange({ value: value.value, code: value.code });
                      setQuery("");
                      onToggle();
                    }}
                  >
                    <img
                      alt={`${value.value}`}
                      src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${value.value}.svg`}
                      className="inline mr-2 h-4 rounded-sm"
                    />
                    <span className={`font-normal truncate ml-2 w-12 `}>
                      +{value.code}
                    </span>
                    <span className={`font-normal truncate ml-4 `}>
                      {value.title}
                    </span>
                  </li>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
